import { render } from "./Loading.vue?vue&type=template&id=73357a2c&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=73357a2c&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73357a2c"]])

export default __exports__